import React from "react";
import "./Body.css";

import {Container, Row, Col} from "reactstrap";

export default class Body extends React.Component {

    render() {
        return (
            <Container className="content-wrapper p-b-0">
                <Row className="top-banner mb-65">
                    <Col>
                        <div>
                            <p className="small-text">SLACK COMMUNITY RULES
                            </p>
                            <h1>
                                Code of Conduct
                            </h1>
                            <p className="small-text">To create a positive experience for all members, you
                                will agree to the following rules by joining the Let's integrate workspace on Slack.</p>
                            <ul className="community-list">
                                <li>
                                    You will treat others with respect and not post any obscene or illegal content
                                </li>
                                <li>
                                    You will be relevant (read channel descriptions before posting) and not spam.
                                </li>
                                <li>
                                    You will keep promotional content to appropriate channels only.
                                </li>
                            </ul>
                            <p className="small-text">If you violate these rules, you may be warned or banned from the
                                Slack workspace with
                                immediate action. Entiros’ community administrators have the final say on everything
                                posted in the Slack workspace. </p>

                        </div>
                    </Col>
                </Row>
                <div className="contact-wrapper">
                </div>
            </Container>
        );
    }
}